<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" titulo="Mi Oficina de Referencia" style="flex: 1 0 100%" />
    <div slot="contenido">
      <div class="tarjetario">
        <OficinaReferencia v-if="visibleOficinaReferencia" class="tarjeta" />
      </div>
    </div>
  </TemplateConMenuLateral>
</template>

<script>
export default {
  computed: {
    visibleOficinaReferencia() {
      return this.$store.state.portfolio.cliente.purezaPuroMMT;
    },
    

  },
};
</script>

<style lang="scss" scoped>
@import "../Menus/menus.scss";
</style>
